import PortalTypes from 'store/actionTypes/portal'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: []
}

const portal = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case PortalTypes.GET_PORTALS_SUCCESS:
      return {
        ...state,
        list: payload?.items
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default portal
